// Theme: opulence-era
// Auto-generated by scripts/materialize-theme-presets.ts
// Source of truth for theme configuration

import type { ThemePreset } from '@/lib/themes/types'

export const THEME_PRESET: ThemePreset = {
  id: 'opulence-era',
  name: 'OPULENCE ERA',
  tagline: 'OPULENCE ERA',
  description: 'Dourado sobre preto absoluto com assinatura de luxo e poder.',
  category: 'system-core',
  tier: 'epic',
  basePrice: 3675,
  swatches: ['#111111', '#1F1A0A', '#C7A95D', '#F3E6BF'],
  baseStyle: {
    cardClasses: '',
    shapeVars: {
      '--border-w': '1px',
      '--radius': '12px',
      '--shadow-card': '0 12px 30px rgba(0, 0, 0, 0.26)',
      '--shadow-card-active': '0 0 22px color-mix(in srgb, var(--primary) 50%, transparent)'
    },
    shellClasses: 'font-mono theme-opulence-era'
  },
  colorVars: {
    '--accent': '#C7A95D',
    '--accent-foreground': '#111111',
    '--background': '#111111',
    '--border': '#7A6010',
    '--card': '#1F1A0A',
    '--card-border-active': 'color-mix(in srgb, var(--primary) 62%, transparent)',
    '--card-completed': 'color-mix(in srgb, var(--card) 92%, var(--background) 8%)',
    '--card-foreground': '#F3E6BF',
    '--card-glow': 'color-mix(in srgb, var(--primary) 10%, transparent)',
    '--coin': 'var(--rarity-legendary)',
    '--destructive': '#ef4444',
    '--destructive-foreground': '#111111',
    '--foreground': '#F3E6BF',
    '--hold-fill': '#C7A95D',
    '--input': '#7A6010',
    '--modal-bg': '#111111',
    '--modal-border': '#7A6010',
    '--modal-overlay-bg': 'rgba(0, 0, 0, 0.75)',
    '--modal-shadow': '0 12px 30px rgba(0, 0, 0, 0.26)',
    '--muted': '#7A6010',
    '--muted-foreground': '#F3E6BF',
    '--nav-active': '#C7A95D',
    '--nav-bg': '#1F1A0A',
    '--popover': '#1F1A0A',
    '--popover-foreground': '#F3E6BF',
    '--primary': '#C7A95D',
    '--primary-foreground': '#111111',
    '--ring': '#C7A95D',
    '--secondary': '#7A6010',
    '--secondary-foreground': '#F3E6BF',
    '--streak': '#C7A95D',
    '--success': '#22c55e',
    '--success-foreground': '#111111',
    '--xp': '#C7A95D',
    '--xp-bg': '#1F1A0A'
  },
  resolvedVars: {
    '--accent': '#C7A95D',
    '--accent-foreground': '#111111',
    '--accent-foreground-hsl': '0 0% 7%',
    '--accent-foreground-oklch': 'from #111111 l c h',
    '--accent-hsl': '43 49% 57%',
    '--accent-oklch': 'from #C7A95D l c h',
    '--background': '#111111',
    '--background-hsl': '0 0% 7%',
    '--background-oklch': 'from #111111 l c h',
    '--border': '#7A6010',
    '--border-hsl': '45 77% 27%',
    '--border-oklch': 'from #7A6010 l c h',
    '--border-w': '1px',
    '--card': '#1F1A0A',
    '--card-border-active': 'color-mix(in srgb, var(--primary) 62%, transparent)',
    '--card-completed': 'color-mix(in srgb, var(--card) 92%, var(--background) 8%)',
    '--card-foreground': '#F3E6BF',
    '--card-foreground-hsl': '45 68% 85%',
    '--card-foreground-oklch': 'from #F3E6BF l c h',
    '--card-glow': 'color-mix(in srgb, var(--primary) 10%, transparent)',
    '--card-hsl': '46 51% 8%',
    '--card-oklch': 'from #1F1A0A l c h',
    '--coin': 'var(--rarity-legendary)',
    '--destructive': '#ef4444',
    '--destructive-foreground': '#111111',
    '--destructive-foreground-hsl': '0 0% 7%',
    '--destructive-foreground-oklch': 'from #111111 l c h',
    '--destructive-hsl': '0 84% 60%',
    '--destructive-oklch': 'from #ef4444 l c h',
    '--foreground': '#F3E6BF',
    '--foreground-hsl': '45 68% 85%',
    '--foreground-oklch': 'from #F3E6BF l c h',
    '--hold-fill': '#C7A95D',
    '--hold-fill-hsl': '43 49% 57%',
    '--hold-fill-oklch': 'from #C7A95D l c h',
    '--input': '#7A6010',
    '--input-hsl': '45 77% 27%',
    '--input-oklch': 'from #7A6010 l c h',
    '--modal-bg': '#111111',
    '--modal-bg-hsl': '0 0% 7%',
    '--modal-bg-oklch': 'from #111111 l c h',
    '--modal-border': '#7A6010',
    '--modal-border-hsl': '45 77% 27%',
    '--modal-border-oklch': 'from #7A6010 l c h',
    '--modal-overlay-bg': 'rgba(0, 0, 0, 0.75)',
    '--modal-shadow': '0 12px 30px rgba(0, 0, 0, 0.26)',
    '--muted': '#7A6010',
    '--muted-foreground': '#F3E6BF',
    '--muted-foreground-hsl': '45 68% 85%',
    '--muted-foreground-oklch': 'from #F3E6BF l c h',
    '--muted-hsl': '45 77% 27%',
    '--muted-oklch': 'from #7A6010 l c h',
    '--nav-active': '#C7A95D',
    '--nav-active-hsl': '43 49% 57%',
    '--nav-active-oklch': 'from #C7A95D l c h',
    '--nav-bg': '#1F1A0A',
    '--nav-bg-hsl': '46 51% 8%',
    '--nav-bg-oklch': 'from #1F1A0A l c h',
    '--popover': '#1F1A0A',
    '--popover-foreground': '#F3E6BF',
    '--popover-foreground-hsl': '45 68% 85%',
    '--popover-foreground-oklch': 'from #F3E6BF l c h',
    '--popover-hsl': '46 51% 8%',
    '--popover-oklch': 'from #1F1A0A l c h',
    '--primary': '#C7A95D',
    '--primary-foreground': '#111111',
    '--primary-foreground-hsl': '0 0% 7%',
    '--primary-foreground-oklch': 'from #111111 l c h',
    '--primary-hsl': '43 49% 57%',
    '--primary-oklch': 'from #C7A95D l c h',
    '--radius': '12px',
    '--ring': '#C7A95D',
    '--ring-hsl': '43 49% 57%',
    '--ring-oklch': 'from #C7A95D l c h',
    '--secondary': '#7A6010',
    '--secondary-foreground': '#F3E6BF',
    '--secondary-foreground-hsl': '45 68% 85%',
    '--secondary-foreground-oklch': 'from #F3E6BF l c h',
    '--secondary-hsl': '45 77% 27%',
    '--secondary-oklch': 'from #7A6010 l c h',
    '--shadow-card': '0 12px 30px rgba(0, 0, 0, 0.26)',
    '--shadow-card-active': '0 0 22px color-mix(in srgb, var(--primary) 50%, transparent)',
    '--streak': '#C7A95D',
    '--streak-hsl': '43 49% 57%',
    '--streak-oklch': 'from #C7A95D l c h',
    '--success': '#22c55e',
    '--success-foreground': '#111111',
    '--success-foreground-hsl': '0 0% 7%',
    '--success-foreground-oklch': 'from #111111 l c h',
    '--success-hsl': '142 71% 45%',
    '--success-oklch': 'from #22c55e l c h',
    '--tint-primary-subtle': 'hsla(43 49% 57% / 0.15)',
    '--xp': '#C7A95D',
    '--xp-bg': '#1F1A0A',
    '--xp-bg-hsl': '46 51% 8%',
    '--xp-bg-oklch': 'from #1F1A0A l c h',
    '--xp-hsl': '43 49% 57%',
    '--xp-oklch': 'from #C7A95D l c h'
  }
}
